export default __webpack_public_path__ + "static/media/html.dfb624e1.svg";